import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/api";

export const WhatsAppFab = () => (
  <a
    href={whatsappLink("Hi, I'm interested in your used cars.")}
    target="_blank"
    rel="noreferrer"
    className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1eb858] text-black rounded-full p-4 shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-110"
    data-testid="whatsapp-fab"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle size={26} />
  </a>
);
